import "./plantationHome.css";
import React, { useState} from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from '@mui/material';
import { PROD } from '../../../common/constants';
import { Container, Stack, Typography, Grid,FormControl, TextField } from '@mui/material';
import { capitalizeFunction, emailUrnPassMaxLength } from "../../../common/commonValidations";
import { toast } from "react-toastify";
import { SubmitIcon } from "../../../common/icons";

function ScmMemberCreatePlant() {
  const navigate = useNavigate();

  const [logModalOpen1, setLogModalOpen1] = useState(false);
const handleLogModalOpen1 = () => setLogModalOpen1(true);
const handleLogModalClose1 = () => setLogModalOpen1(false);
  const [details, setDetails] = useState({
    "urn": ""
  });

  const [errorMessage, setErrorMessage] = useState({
    urnError: "",

  })

  const handleChange = (e) => {
    setDetails({
        ...details,
        [e.target.name]:e.target.value,
      });
    if (e.target.name === "urn") {
        setErrorMessage({ ...errorMessage, urnError: "" });
      }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const userData = {
        urn: details.urn,   
      }; 
      if (!details.urn) {
        toast.error("Please enter a grower URN to create plantation batch")
      } else {
        navigate("growerBatchCreate", { state: { data: userData } });
      }
  }


  return (
    <>
      <Container maxWidth="xxl">
      {!PROD && <p className='pageNumberingResc'>RES20</p>}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h5" gutterBottom>
             Please enter grower URN to create plantation batch
          </Typography>
        </Stack>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={3}>
            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
               <TextField fullWidth
                  label="URN"
                  name="urn"
                  placeholder="e.g. URN-KAKGR00123"
                  onChange={(e) => handleChange(e)}
                  inputProps={{
                    maxLength: emailUrnPassMaxLength
                }}
                  sx={{ paddingRight: '3%', mt: 2, bgcolor: 'white' }}
               />
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3}>
            <Button startIcon={<SubmitIcon />} sx={{ minWidth: 100, mt:3}} variant="contained"  onClick={(e) => onSubmit(e)}>Submit</Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
export default ScmMemberCreatePlant;
